import { Box, Link, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch,useSelector } from "react-redux";
import { setState as ApprovalQuotaState } from "./../Approvals/quota/quotaSlice";
import { setState as ApprovalScenarioState } from "./../Approvals/scenario/scenarioApprovalSlice";
import { setState as ApprovalQuotaModificatioState } from "./../Approvals/quotaModification/quotaModificationSlice";

export default function PendingActionsCard({
  text,
  number,
  link,
  redirectionUrl,
  isNavigate,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { selectedCountry, selectedCountryID } = useSelector(
		(store) => store.dashboard);

  // if (isNavigate == "quota") {
  //   dispatch(ApprovalQuotaState("navigatedCountryID", selectedCountryID));
  // } else if (isNavigate == "scenario") {
  //   dispatch(ApprovalScenarioState("navigatedCountryID", selectedCountryID));
  // } else if (isNavigate == "quota-modification") {
  //   dispatch(
  //     ApprovalQuotaModificatioState("navigatedCountryID", selectedCountryID)
  //   );
  // }

  function handleClick() {
    if (link && link.includes("quota-modification")) {
			dispatch(ApprovalQuotaModificatioState("redirectedFromDashboard", true));
		} else if (link && link.includes("quota")) {
			dispatch(ApprovalQuotaState("redirectedFromDashboard", true));
		}
    else if (link && link.includes("scenario")) {
			dispatch(ApprovalScenarioState("redirectedFromDashboard", true));
		}
		navigate(link, { state: { selectedCountry, selectedCountryID } });
  }

  return (
    <Box
      sx={{
        backgroundColor: "grey.light",
        p: 1,
        borderRadius: 1,
        flex: 1,
        alignItems: "center",
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 550, fontSize: 16 }}>
        {text}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ textAlign: "right", color: "darkred.main",fontSize:19 }}
      >
        {number == 0 && number}
        {number != 0 && (
          <Link sx={{ cursor: "pointer",color: "darkred.main",fontSize:19 }} onClick={handleClick}>
            {number}
          </Link>
        )}
      </Typography>
    </Box>
  );
}
